let TeamsOld = {
    init() {
        this.bind();
    },

    bind() {
        this.addForm();
        this.editForm();
        this.form();
        this.delete();
    },

    addForm() {
        let _this = this;

        const form = $('#teamOldForm');

        if (form.length) {
            $(document).on('click', '.add-group', () => {
                form.find('#teamId').val('');
                form.find('#teamName').val('');

                form.resetForm();
            });
            let submitBtn = Ladda.create(form.find('[type=submit]')[0]);

            form.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        window.location.reload();
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },

    editForm() {
        let _this = this;

        const form = $('#teamOldForm');
        const modal = $('#teamOldModal');

        $(document).on('click', '.edit-team', function () {
            const id = $(this).data('id');
            const row = $(this).closest('tr');

            $.get('/teams-old/' + id + '/json', response => {
                if (response.success) {
                    const team = response.data;

                    form.find('#teamName').val(team.name);
                    form.find('#teamId').val(team.id);

                    modal.modal('show');
                }
            });
        });
    },

    delete() {
        $(document).on('click', '.delete-team', function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/teams/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Team has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form() {
        let _this = this;
        const form = $('#teamOldForm');
    },
};

$().ready(function () {
    window.TeamsOld = TeamsOld;
    window.TeamsOld.init();
});
